import {
  createReservation,
} from "../api/services/reservationService";

import {
  getStripeConfig,
  getFiservConfig,
  getPaymentCredentials,
} from "../api/services/paymentService";

// import { startFiservPayment } from "./fiservProvider";
import { startStripePayment  } from "./stripeProvider";

/* ─────────────────────────────────────────────────────
   TESTING KEY
   Replace with your Routes Stripe test publishable key.
   When Java middleware is ready:
     1. Import getStripeConfig from paymentService
     2. Delete this constant
     3. Replace: const publishableKey = STRIPE_TEST_KEY
         with:   const { publishableKey } = await getStripeConfig(currency);
   ───────────────────────────────────────────────────── */
// const STRIPE_TEST_KEY = "pk_test_0knnaAcQeAPPSsSL9UP6uBg4005rjvcxQH";

/* ─────────────────────────────────────────────────────
   INTERNAL STATE
   ───────────────────────────────────────────────────── */
let paymentInProgress = false;

/* =========================================================
   STEP 1 — CREATE RESERVATION + PREPARE SESSION
   ========================================================= */

export const preparePaymentSession = async ({
  reservationPayload,
  currency,
  amount,
  email,
  phone,
  paymentProvider,
}) => {
  const provider = (paymentProvider || "FISERV").toUpperCase();

  /* ── Stripe path — createReservation first, then getStripeConfig with reservationNumber ── */
if (provider === "STRIPE") {
  let reservationResult;
  try {
    reservationResult = await createReservation(reservationPayload);
  } catch (e) {
    console.error("reservation/create failed:", e);
    return {
      success: false,
      errorType: "RESERVATION_FAILED",
      message: "We couldn't create your reservation. Please try again.",
    };
  }

  if (!reservationResult.reservation_number) {
    return {
      success: false,
      errorType: "RESERVATION_FAILED",
      message: "We couldn't create your reservation. Please try again.",
    };
  }

  // TODO: uncomment when backend is ready
  const stripeConfigResult = await getStripeConfig(reservationResult.reservation_number);

  return {
    success: true,
    provider: "STRIPE",
    reservationNumber: reservationResult.reservation_number,
    publishableKey: stripeConfigResult.publishableKey,
    clientSecret: stripeConfigResult.clientSecret,
    amount,
    currency,
    email,
  };
}

  /* ── Fiserv path ── */
  let reservationNumber;
  try {
    const reservation = await createReservation(reservationPayload);
    reservationNumber = reservation.reservation_number;
  } catch (error) {
    console.error("reservation/create failed:", error);
    return {
      success: false,
      errorType: "RESERVATION_FAILED",
      message: "We couldn't create your reservation. Please try again.",
    };
  }
  try {
    const credentialsPayload = {
      Currency: currency.toUpperCase(),
      Total_Price: Number(amount.toFixed(2)),
      Email: email,
      Phone: phone,
      reservation_number: reservationNumber,
    };

    const [credentials, config] = await Promise.all([
      getPaymentCredentials(credentialsPayload),
      getFiservConfig(reservationNumber),
    ]);

    if (!credentials?.access_token || !credentials?.session_id) {
      throw new Error(
        "Missing access_token or session_id in Fiserv credentials response",
      );
    }

    return {
      success: true,
      provider: "FISERV",
      reservationNumber,
      accessToken: credentials.access_token,
      sessionId: credentials.session_id,
      config,
    };
  } catch (error) {
    console.error("payment credentials/config failed:", error);
    return {
      success: false,
      errorType: "PAYMENT_SETUP_FAILED",
      message: "Unable to initialize payment. Please try again.",
    };
  }
};;

